import React from "react";
import { withRouter } from "react-router-dom";
import EllipsisButton from "../../../../components/EllipsisButton/component";
import { List} from "antd";

const styles = {
  textAlign: "left",
  paddingTop: 0,
  paddingBottom: 20,
  position: "relative",
  overflow: "allow"
};
function UserList({ users, sendEmail, updateRole, language, deleteUser }) {
  window.onclick = function(e) {
    var ellipsisButton = document.getElementsByClassName("ellipsisButton");

    var dropdownArray = document.getElementsByClassName("dropdown-content");
    var i;
    for (i = 0; i < dropdownArray.length; i++) {
      if (
        (dropdownArray[i].style.display === "block" &&
          dropdownArray[i].contains(e.target)) ||
        ellipsisButton[i].contains(e.target)
      ) {
      } else {
        dropdownArray[i].style.display = "none";
      }
    }
  };

  return (
    <List
      itemLayout="horizontal"
      dataSource={users}
      renderItem={(item, index) => (
        <List.Item
          //   actions={[
          //     <Button onClick={() => history.push(`/admin/blog/${item.id}`)}>
          //       <Icon type="form" />
          //     </Button>,
          //     <Button onClick={() => deleteBlogPost(item.id)} type="danger">
          //       <Icon type="delete" />
          //     </Button>
          //   ]}
          style={
            index === 0
              ? { ...styles }
              : { ...styles, borderTop: "1px solid #fff" }
          }
        >
          <List.Item.Meta
            style={{ alignItems: "center" }}
            title={
              item.email
                ? item.email
                : "Der eksistere ingen email for denne bruger"
            }
            name={
              item.navn ? item.navn : "Navn eksistere ikke for denne bruger"
            }
            description={"Rolle: " + item.role}
          />

          {item.name ? (
            <span style={{ color: "black" }}> {item.name} </span>
          ) : (
            <span>Navn eksistere ikke for denne bruger</span>
          )}
          <EllipsisButton
            id={item.id}
            choices={[
              {
                method: [updateRole, sendEmail],
                title: "Send TA invitation",
                message: "Email er sendt"
              },
              {
                method: [deleteUser],
                title: "Slet bruger",
                message: "Bruger er slettet"
              }
            ]}
            language={language}
            item={item}
          />
        </List.Item>
      )}
    />
  );
}

export default withRouter(UserList);



// WEBPACK FOOTER //
// ./src/pages/Admin/UsersCollection/UserList/component.js